import { z } from 'zod';

import { BackupMethodOptions } from '../../TwoFaEnablingWizard.constants';
import { messages } from './StepBackupMethods.messages';

export const schema = z.object({
    backupMethod: z.nativeEnum(BackupMethodOptions, { message: messages.errorBackupMethodEmpty }),
});
